export default "__VITE_ASSET__ce11a3cb__"